/**
 * This file is created manually
 * You can change the content
 *
 */

import H3 from './typography/H3'
export * from './typography/H3'
export default H3
